import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable';
import { useSelector } from 'react-redux';
import Flatpickr from "react-flatpickr";
import ModalCrearRecepcionVehiculo from '../../Components/modals/ModalCrearRecepcionVehiculo';
import ModalLeerRecepcionVehiculo from '../../Components/modals/ModalLeerRecepcionVehiculo';
import ModalModificarRecepcionVehiculo from '../../Components/modals/ModalModificarRecepcionVehiculo';
import recepcionesVehiculosHooks from '../../Components/Hooks/RecepcionesVehiculosHooks';
import useCreateRecepcionVehiculo from '../../Components/Hooks/useCreateRecepcionVehiculo';
const RecepcionVehiculos = () => {
  document.title = "Historial Recepciones | Siga ERP";
  const d = new Date();
  let hoy = d.toISOString().substring(0, 10)
  d.setDate(1)
  let inicioMes = d.toISOString().substring(0, 10)
  const [fechaInicio, setFechaInicio] = useState(inicioMes)
  const [fechaTermino, setFechaTermino] = useState(hoy)
  const [refreshKey, setRefreshKey] = useState(0)
  const [selectedRecepcion, setSelectedRecepcion] = useState('');
  const [citaPrecargada, setCitaPrecargada] = useState({});

  const [modalCrear, setModalCrear] = useState(false);
  const [modalLeer, setModalLeer] = useState(false);
  const [modalModificar, setModalModificar] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const location = useLocation();

  const toggleModalCrear = () => {
    const newModalState = !modalCrear;
    setModalCrear(newModalState);
    setValidationError(null); // Clear error when closing
    if (!newModalState) {
      // Al cerrar el modal, limpiar citaPrecargada
      setCitaPrecargada({});
    }
  };

  const handleCrear = () => {
    setModalCrear(true);
  }

  const handleVerRecepcion = (recepcion) => {
    setSelectedRecepcion(recepcion);
    setModalLeer(true);
  }

  const validateRecepcionData = (datos) => {
    const requiredFields = ['patente', 'contacto', 'telefono'];
    const missingFields = requiredFields.filter(field => !datos[field] || datos[field].trim() === '');
    if (missingFields.length > 0) {
      return `Los siguientes campos son obligatorios: ${missingFields.join(', ')}`;
    }
    return null;
  };

  const handleGuardarRecepcion = async (datosRecepcion) => {
    const validationError = validateRecepcionData(datosRecepcion);
    if (validationError) {
      setValidationError(validationError);
      return false;
    }
    setValidationError(null);
    const result = await createRecepcion(datosRecepcion);
    console.log('Resultado de guardar recepción:', result);
    if (result.success) {
      setRefreshKey(prev => prev + 1);
      setModalCrear(false);
      return true;
    }
    return false;
  };


  const formatDate = (date) => {
    if (!date) return '';
    const _date = new Date(date)
    const year = _date.getFullYear();
    const month = String(_date.getMonth() + 1).padStart(2, '0');
    const day = String(_date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const handleFechaInicioChange = (date) => {
    setFechaInicio(formatDate(date));
  };

  const handleFechaTerminoChange = (date) => {
    setFechaTermino(formatDate(date));
  };


  const tenantId = useSelector((state) => state.Context.tenantId)
  const empresa = useSelector((state) => state.Context.empresa)
  const departamento = useSelector((state) => state.Context.departamento)
  const userInfo = useSelector((state) => state.UserInfo.userInfo)

  const { recepciones, loading, error } = recepcionesVehiculosHooks(fechaInicio, fechaTermino, refreshKey)
  const { createRecepcion, loading: createLoading, error: createError } = useCreateRecepcionVehiculo();

  // Efecto para manejar redirección desde Citas con datos precargados
  useEffect(() => {
    if (location.state) {
      if (location.state.citaPrecargada) {
        // Cita no recepcionada: abrir modal crear con datos precargados
        setCitaPrecargada(location.state.citaPrecargada);
        setModalCrear(true);
      } else if (location.state.verRecepcion) {
        // Cita ya recepcionada: abrir modal leer
        setSelectedRecepcion(location.state.verRecepcion);
        setModalLeer(true);
      }

      // Limpiar el estado de navegación para evitar re-apertura al refrescar
      window.history.replaceState({}, document.title);
    }
  }, [location]);


  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "id_recep",
        enableColumnFilter: false,
      },
      {
        header: "Fecha",
        accessorKey: "fecha",
        enableColumnFilter: false,
      },
      {
        header: "Hora",
        accessorKey: "hora",
        enableColumnFilter: false,
      },
      {
        header: "Patente",
        accessorKey: "patent",
        enableColumnFilter: false,
      },
      {
        header: "Cliente",
        accessorKey: "clipro",
        enableColumnFilter: false,
      },
      {
        header: "OT",
        accessorKey: "ot_presupuesto",
        enableColumnFilter: false,
      }
    ],
    []
  );


  const handleCellClick = (cellInfo) => {
    console.log('Celda clickeada:', cellInfo);
    console.log('Columna:', cellInfo.columnId);
    console.log('Valor:', cellInfo.value);
    console.log('Datos completos de la fila:', cellInfo.rowData);
    setSelectedRecepcion(cellInfo.rowData.id_recep);
    if (cellInfo.columnId == 'id_recep' && cellInfo.value != null) {
      handleVerRecepcion(cellInfo.value);
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Recepcion Vehiculos</h5>
                  <div className="mt-0">
                    <Input
                      type="text"
                      value={selectedRecepcion}
                      onChange={(e) => setSelectedRecepcion(e.target.value)}
                      style={{ width: '250px' }}
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <Label className="form-label mb-0 me-2">Desde</Label>
                    <div className="mt-0  me-2">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaInicio}
                        onChange={handleFechaInicioChange}
                      />
                    </div>
                    <Label className="form-label mb-0 me-2">Hasta</Label>
                    <div className="mt-0 me-2">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaTermino}
                        onChange={handleFechaTerminoChange}
                      />
                    </div>
                    <Button color="info" className="me-2" onClick={() => { if (selectedRecepcion) setModalLeer(true); }} disabled={!selectedRecepcion}>
                      <i className="ri-eye-line me-1"></i>Leer
                    </Button>
                    <Button color="warning" className="me-2" onClick={() => { if (selectedRecepcion) setModalModificar(true) }} disabled={!selectedRecepcion}>
                      <i className="ri-edit-line me-1"></i>Modificar
                    </Button>
                    <Button color="primary" className="me-2" onClick={handleCrear} disabled={tenantId && empresa && userInfo?.name && loading}>
                      <i className="ri-add-line me-1"></i>Crear
                    </Button>
                  </div>
                </CardHeader>
                <CardBody>
                  {loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> :
                    <TableContainer
                      columns={(columns || [])}
                      data={(recepciones || [])}
                      customPageSize={15}
                      isGlobalFilter={true}
                      SearchPlaceholder='Buscar...'
                      onCellClick={handleCellClick}
                    />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ModalCrearRecepcionVehiculo
        isOpen={modalCrear}
        toggle={toggleModalCrear}
        onSave={handleGuardarRecepcion}
        validationError={validationError}
        citaPrecargada={citaPrecargada}
      />
      <ModalLeerRecepcionVehiculo
        isOpen={modalLeer}
        toggle={() => setModalLeer(false)}
        idRecepcion={selectedRecepcion}
      />
      <ModalModificarRecepcionVehiculo
        isOpen={modalModificar}
        toggle={() => setModalModificar(false)}
        onSave={() => {
          setRefreshKey(prev => prev + 1);
        }}
        selectedRecepcion={selectedRecepcion}
      />
    </React.Fragment>
  )
}

export default RecepcionVehiculos;